// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import store from './router/store'

import './utils/axios';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import txButtons from './common/tx-buttons.vue'
import txVideo from './common/tx-video.vue'
import txVideoZh from './common/tx-video-zh.vue'
import txImage from './common/tx-image.vue'
import txImageApp from './common/tx-image-app.vue'

//全局组件
const components=[txButtons,txVideo,txImage,txImageApp,txVideoZh]
components.forEach(component=>{
  Vue.component(component.name,component)
})

Vue.use(ElementUI)
Vue.use(VueAwesomeSwiper)

// animate.css
import animated from'animate.css'
Vue.use(animated)

// reset.css
import '@/assets/reset.css'

import utils from './utils'
Vue.prototype.utils = utils

import globalVariable from '@/router/globalVariable.js'//全局
Vue.prototype.globalVariable = globalVariable

Vue.config.productionTip = false

/* eslint-disable no-new */
const vm =new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
export default vm



// WEBPACK FOOTER //
// ./src/main.js